// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=text], textarea {
  border-radius: 30px;
  height: 30px;
  border: 1px solid #ccc;
  width: 100%;
  padding-left: 15px;
}

textarea {
  min-height: 90px;
  width: 97%;
}

button[type=reset] {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: calc(100% + 17px);
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #a41f35;
  cursor: pointer;
}

button[type=button] {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: 55%;
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #023970;
  cursor: pointer;
}

.pull-right {
  float: right;
}

input[type=date] {
  border-radius: 30px;
  height: 34px;
  border: 1px solid #ccc;
  width: calc(100% + 5px);
  padding-left: 10px;
}

select {
  border-radius: 30px;
  height: 34px;
  border: 1px solid #ccc;
  width: calc(100% + 17px);
  padding-left: 10px;
}

::placeholder {
  color: #545454;
}

.row {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
  margin-top: 8px;
}

.table-column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
}

td:nth-child(1) {
  padding-left: 20px;
}

.resetstyle {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: calc(100% + 17px);
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #a41f35 !important;
  cursor: pointer;
}

.aligncenter {
  text-align: center !important;
}

td {
  font-family: "Lato", sans-serif;
  font-size: 11px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.validation-error {
  border: 1px solid #f00 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/intern/observation/observation-professional/observation-professional.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,eAAA;AAAF;;AAGA;EACE,6BAAA;AAAF;;AAGA;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,iCAAA;AAAF","sourcesContent":["input[type=text], textarea {\n  border-radius: 30px;\n  height: 30px;\n  border: 1px solid #ccc;\n  width: 100%;\n  padding-left: 15px;\n}\n\ntextarea {\n  min-height: 90px;\n  width: 97%;\n}\n\nbutton[type=reset] {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: calc(100% + 17px);\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #a41f35;\n  cursor: pointer;\n}\n\n\nbutton[type=button] {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: 55%;\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #023970;\n  cursor: pointer;\n}\n\n.pull-right {\n  float: right;\n}\n\ninput[type=date] {\n  border-radius: 30px;\n  height: 34px;\n  border: 1px solid #ccc;\n  width: calc(100% + 5px);\n  padding-left: 10px;\n}\n\nselect {\n  border-radius: 30px;\n  height: 34px;\n  border: 1px solid #ccc;\n  width: calc(100% + 17px);\n  padding-left: 10px;\n}\n\n::placeholder {\n  color: #545454;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n  margin-right: 20px;\n  margin-top: 8px;\n}\n\n.table-column {\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n  margin-right: 20px;\n}\n\ntd:nth-child(1) {\n  padding-left: 20px;\n}\n\n.resetstyle {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: calc(100% + 17px);\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #a41f35 !important;\n  cursor: pointer;\n}\n\n.aligncenter {\n  text-align: center !important;\n}\n\ntd {\n  font-family: 'Lato', sans-serif;\n  font-size: 11px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ccc;\n}\n\n.validation-error {\n  border: 1px solid #f00 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
